import React, { lazy } from 'react'

const TermsOfUsePage = lazy(() => import('./TermsOfUsePage'))

export { TermsOfUsePage }
